var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(!_vm.$route.meta.isPublic)?_c('private',[_c('router-view')],1):_vm._e(),(_vm.$route.meta.isPublic)?_c('public',[_c('router-view')],1):_vm._e(),(_vm.spinning)?_c('div',{staticClass:"spinning"},[_c('a-spin',{attrs:{"tip":"Loading...","size":"large","spinning":_vm.spinning,"delay":_vm.delayTime}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }